import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@ui/dialog.tsx';
import type {
  LogicTypeStepWorkspaceReadModel,
  RewardGroupedRewardReadModel
} from '@r/api/generated/client.schemas.ts';
import { UpdateStepRewardForm } from './update-step-reward-form.tsx';

interface UpdateStepRewardDialogProps {
  reward: RewardGroupedRewardReadModel | null;
  step: LogicTypeStepWorkspaceReadModel | null;
  rewardShopId: number | null;
  rewardShopLoading: boolean;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

/** Coque modale autour de {@link UpdateStepRewardForm}. */
export const UpdateStepRewardDialog: FC<UpdateStepRewardDialogProps> = ({
  reward,
  step,
  rewardShopId,
  rewardShopLoading,
  isOpen,
  onOpenChange,
  onSuccess
}) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onOpenChange(false);
    onSuccess();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="p-10 !rounded-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl">
            {t('admin.settings.steps.rewards.update.dialog.title')}
          </DialogTitle>
          <DialogDescription>
            {t('admin.settings.steps.rewards.update.dialog.description')}
          </DialogDescription>
        </DialogHeader>

        {isOpen && reward && step ? (
          <UpdateStepRewardForm
            key={reward.id}
            reward={reward}
            step={step}
            rewardShopId={rewardShopId}
            rewardShopLoading={rewardShopLoading}
            onSuccess={handleSuccess}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};
